import { render, staticRenderFns } from "./ResellerListTable.vue?vue&type=template&id=d22f4842&scoped=true&lang=html&"
import script from "./ResellerListTable.vue?vue&type=script&lang=js&"
export * from "./ResellerListTable.vue?vue&type=script&lang=js&"
import style0 from "./ResellerListTable.vue?vue&type=style&index=0&id=d22f4842&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22f4842",
  null
  
)

export default component.exports